export default "f4cfc334c3a84bea.png"